import React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useSelectionStore } from '../../../../EdgeDocs/EdgeDocsCore/stores/useSelectionStore';

export const CompositionDragPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    const root = editor.getRootElement();
    if (!root) return;
    const setComposing = useSelectionStore.getState().setComposing;
    const setDragging = useSelectionStore.getState().setDragging;

    const onCompStart = () => setComposing(true);
    const onCompEnd = () => setComposing(false);
    const onDragStart = () => setDragging(true);
    const onDragEnd = () => setDragging(false);

    root.addEventListener('compositionstart', onCompStart);
    root.addEventListener('compositionend', onCompEnd);
    root.addEventListener('dragstart', onDragStart);
    root.addEventListener('dragend', onDragEnd);
    return () => {
      root.removeEventListener('compositionstart', onCompStart);
      root.removeEventListener('compositionend', onCompEnd);
      root.removeEventListener('dragstart', onDragStart);
      root.removeEventListener('dragend', onDragEnd);
    };
  }, [editor]);

  return null;
};


